import { render } from "./ArtDialog.vue?vue&type=template&id=4bdb4657"
import script from "./ArtDialog.vue?vue&type=script&lang=js"
export * from "./ArtDialog.vue?vue&type=script&lang=js"

import "./ArtDialog.vue?vue&type=style&index=0&id=4bdb4657&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__